<template>
  <div class="contact-table">
    <div style="text-align: right; margin-bottom:16px;">
      <el-button @click="$refs.newcontactDialog.dialogVisible = true" size="small" style="color:#4f5d78;"> 新建联系人</el-button>
    </div>
    <el-table
      class="table fine-scroll-bar "
      :data="copyContactList"
      :highlight-current-row="false"
      :header-cell-style ="{ background:'#F5F7FA'}"
      style="width: 100%; border:1px solid #E5E8ED"
    >
      <!-- 联系人 -->
      <el-table-column 
        prop="contactName" 
        label="联系人" 
        width="120"  
        :fixed="copyContactList.length ? 'left' : null"
      >
        <template slot-scope="scope">
          <span 
            v-if="scope.row.showContactInfo == 20 "
            style="cursor:pointer;color:#066EB7" 
            @click="goContactDetail(scope.row)"
          >
            {{scope.row.contactName | noText}} 
          </span>
          <span v-else> {{scope.row.contactName | noText}}  </span>
        </template>
      </el-table-column>
      <!-- 职务 -->
      <el-table-column prop="title" label="职务" width="140">
        <template slot-scope="scope">
<!--           
          <el-tooltip effect="dark" :disabled="offsetWidth<155" placement="top"  >
            <div slot="content">{{scope.row.titleStr}}</div>
            <div 
              style="width:130px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
              @mouseover="mouseover"
            >
            <span ref="titleRef">{{scope.row.titleStr | noText}} </span>
            </div>
          </el-tooltip> -->
          <div >
            {{scope.row.titleStr | noText}} 
          </div>
        </template>
      </el-table-column>
      <!-- 邮箱  showContactInfo是否可以看联系方式信息 10=无权限查看 20=有权限查看-->
      <el-table-column prop="email" label="邮箱" width="170" >
        <template slot-scope="scope">
          <div  
            @mouseenter="showEmailIcon(scope.row)" 
            @mouseleave="emailIcon=false" 
            v-if="scope.row.showContactInfo == 20"
          >
          <div >
            <el-tooltip
              class="referenceemail"
              effect="dark"
              placement="top-start"
            >
            <div slot="content">
              <div v-if="scope.row.emailStateType==1">
                退订邮箱
              </div>
              <div v-if="scope.row.emailStateType==2">
                手动排除邮箱
              </div>
              <div v-if="scope.row.emailStateType==3">
                发送过程中因邮件地址不存在、邮件地址被注销、邮件地址拼写错误等原因造成的发件人所发出的信息不能被收件人正常接收
              </div>
              <div v-if="scope.row.emailStateType==4">
                由于暂时的原因，如收件人邮箱已满、收件人远程服务器暂时性故障等，导致邮件不能顺利被送达
              </div>
              <div v-if="scope.row.emailStateType==0">
                有效邮箱
              </div>
            </div>
              <i
                class="i"
                style="cursor: pointer"
                :class="'emailType'+scope.row.emailStateType"
              ></i>
            </el-tooltip>
            <span  style="margin-right:4px;">{{scope.row.email | noText}}</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class="iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.email}`)"
              v-show="iconId == scope.row.id && scope.row.email && emailIcon"
            ></i>
          </div>
          </div>

          <div v-else>
            <el-tooltip content="获取该联系人将消费1个点数" placement="top">
              <el-button 
                style="width:112px;height:36px;font-size: 12px; "
                @click="getMsg(scope.row)"
                v-if="scope.row.showContactInfo ==10 && !showContactMsg && cutId==0 "
                :disabled="disableGetContact"
                class="getContactButton"
              > 单击获取该联系人
              </el-button>
              <div v-else  @mouseenter="showEmailIcon(scope.row)" @mouseleave="emailIcon=false">
                <span style="margin-right:4px;">{{scope.row.email | noText}}</span>
                <i 
                  style="cursor:pointer;color:#066EB7;font-size: 12px;"
                  class="iconfont icon-icon-fuzhi" 
                  @click="setClipBoardText($event,`${scope.row.email}`)"
                  v-show="iconId == scope.row.id &&  scope.row.email "
                ></i>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <!-- 手机 -->
      <el-table-column
        prop="mobile"
        label="手机"
        width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.showContactInfo ==10 && !showContactMsg" class="data-hiding"></div>
          <div 
            v-else 
            @mouseenter="showPhoneIcon(scope.row)" 
            @mouseleave="phoneIcon=false"
          >
            <span v-if="scope.row.mobile " style="margin-right:4px;"> {{scope.row.codeTelStr }} {{scope.row.mobile }}</span>
            <span v-else style="margin-right:4px;">---</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class="iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.codeTelStr ? scope.row.codeTelStr:'' } ${scope.row.mobile}`)"
              v-show="iconId == scope.row.id &&  scope.row.mobile && phoneIcon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <!-- 电话号  -->
      <el-table-column prop="tel" label="电话号" width="130">
          <template slot-scope="scope">
          <div v-if="scope.row.showContactInfo ==10 && !showContactMsg" class="data-hiding"></div>
          <div 
            v-else 
            @mouseenter="showMobileIcon(scope.row)" 
            @mouseleave="mobileIcon=false"
          >
           <span v-if="scope.row.tel " style="margin-right:4px;"> {{scope.row.codeTelStr }} {{scope.row.tel }}</span>
            <span v-else style="margin-right:4px;">---</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class="iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.codeTelStr ? scope.row.codeTelStr :'' } ${scope.row.tel}`)"
              v-show="iconId == scope.row.id &&  scope.row.tel && mobileIcon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <!-- linkedinLink -->
      <el-table-column prop="linkedinLink" label="Linkedin" width="80">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.linkedinLink">---</span>
            <span 
              v-else 
              @click="linkedinLinkShow(scope.row.linkedinLink)" 
              class="iconfont icon-yingling" 
              style="cursor:pointer;color: #066EB7;"
            ></span>
          </div>
        </template>
      </el-table-column>
      <!-- whatsApp -->
      <el-table-column prop="whatsApp" label="WhatsApp" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.showContactInfo == 10 && !showContactMsg" class="data-hiding"></div>
          <div 
            v-else 
            @mouseenter="showWhatsAppIcon(scope.row)" 
            @mouseleave="whatsAppIcon=false"
          >
            <span  style="margin-right:4px;">{{scope.row.whatsApp | noText}}</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class="iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.whatsApp}`)"
              v-show="iconId == scope.row.id && scope.row.whatsApp && whatsAppIcon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <!-- 微信号 -->
      <el-table-column  prop="wechatNo" label="微信号" width="180">
          <template slot-scope="scope">
          <div v-if="scope.row.showContactInfo ==10 && !showContactMsg" class="data-hiding"></div>
          <div 
            v-else 
            @mouseenter="showWeChatIcon(scope.row)" 
            @mouseleave="weChatIcon=false"
          >
            <span style="margin-right:4px;">{{scope.row.wechatNo | noText}}</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class=" iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.wechatNo}`)"
              v-show="iconId == scope.row.id && scope.row.wechatNo && weChatIcon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <!-- 最近阅读邮件时间 -->
      <el-table-column  prop="wechatNo" label="最近阅读邮件时间" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.recentlyReadTime | format('YYYY-MM-DD HH:mm')  }}</div>
          <!-- <div v-if="scope.row.showContactInfo ==10 && !showContactMsg" class="data-hiding"></div>
          <div 
            v-else 
            @mouseenter="showWeChatIcon(scope.row)" 
            @mouseleave="weChatIcon=false"
          >
            <span style="margin-right:4px;">{{scope.row.wechatNo | noText}}</span>
            <i 
              style="cursor:pointer;color:#066EB7;font-size: 12px;"
              class=" iconfont icon-icon-fuzhi" 
              @click="setClipBoardText($event,`${scope.row.wechatNo}`)"
              v-show="iconId == scope.row.id && scope.row.wechatNo && weChatIcon"
            ></i>
          </div> -->
        </template>
      </el-table-column>
      <!-- 编辑删除
      <el-table-column align="center">
        <template  slot-scope="scope">
          <el-dropdown placement='bottom' size="mini"  >
            <span class=" el-icon-more" style="transform: rotate(90deg); color: #606266;"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="color:#066EB7;" @click.native="editConcat(scope.row)" >编辑</el-dropdown-item>
              <el-dropdown-item style="color:#EF2A2A;" @click.native="deleteConcat(scope.row.id)">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
      
    </el-table>
    <div style="text-align: center; margin-top: 26px; margin-bottom:31px" >
      <!-- :current-page="currentPage4" -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        :page-size="5"
        :currentPage.sync="currentPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 新建、编辑联系人 -->
    <NewContactDialog
      ref="newcontactDialog"
      @getContactList="getContactList"
      :copyDetailData="copyDetailData"
    />
    <!-- 购买图片弹框点数不足 -->
    <!-- <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog"/> -->

  </div>
</template>

<script>
import setClipBoardText from '@/utils/clipboard';
import NewContactDialog from "@/components/custom/newcontactDialog";
import ContactDetail from '@/components/custom/contactDetail'
// import vipBoxDialog from "@/components/common/VIPdialog"

import { mapMutations } from 'vuex'
import {
  contactList,
  addAddressee
} from '@/utils/api/customerdetail';

export default {
  components:{
    NewContactDialog,
    ContactDetail,
    // vipBoxDialog
  },
  props:['copyDetailData'],
  data(){
    return {
      iconId: '' , 
      cutId:0,
      linkinUrl:'',
      linkeinVisible:false,
      emailIcon: false,
      phoneIcon:false,
      mobileIcon:false,
      whatsAppIcon:false,
      weChatIcon:false,
      contactList:[],  //联系人列表数据
      copyContactList:[],
      currentPage: 1,
      totalNum:0,
      contactDetail:{},
      companyData: {
        id: null, // 当前联系人id
        ids: [], // 当前页的联系人id集合
        index: 0, // 当前索引
        cid: null, // 当前客户id
        cids: [], // 当前页的客户id集合
      },
      emailList:[],
      showContactMsg:false,
      addressList:[],
      disableGetContact:false,
      // vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度

    }

  },
  watch: {
    copyDetailData: {
      handler(newVal) {
        if(newVal.id) {
          this.getContactList(this.copyDetailData.id, 1)
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods:{
    ...mapMutations('linkedin', ['SET_VISIBLE', 'SET_LINKIN_URL']),
    setClipBoardText,
    // 增加到地址簿
    getMsg(val){
      this.disableGetContact =true
      if(this.copyDetailData.id == val.id){
        this.cutId = 1
      }
      this.addressList.push(val.sourceUserId)
      this.getAddress(this.addressList)
      this.addressList=[]
    },
     // 添加到收件人
    getAddress(val){
      const params={
        contactIds: val ? val : []
      }
      addAddressee(params)
        .then(res=>{
            if(res.rspResult.bizCode == 200){
              if(this.copyContactList.sourceUserId == val){
                this.showContactMsg = true;
              }
              this.disableGetContact =true
              this.getContactList()
            }
            // else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
            //   this.vipCode=res.rspResult.bizCode
            //   this.$refs.vipBoxDialog.centerDialogVisible=true
            // }else{
            //   console.error('添加到收件人失败');
            // }
          })
        .catch(err=>{
          this.disableGetContact=false
          console.error('添加到收件人失败',err);
        })
    },
    // 获取联系人列表
    getContactList(id,curPage){
      const params = {
        customerId:id ? id:  this.copyDetailData.id,
        curPage: curPage ? curPage : this.currentPage,
        pageSize: 5,
        attribute: "",
        sortType: 0
      }
      contactList(params)
        .then((res)=>{
          if(res.rspResult.bizCode == 200){
            this.contactList = res.rspPageData.list || [];
            this.totalNum = res.rspPageData.totalNum
            this.copyContactList = JSON.parse(JSON.stringify(this.contactList));
          }
        })
        .catch((err)=>{
          console.error('获取联系人列表失败',err);
        })
    },
    showEmailIcon(val){
      this.emailIcon = true;
      this.iconId = val.id
    },
    showPhoneIcon(val){
      this.phoneIcon = true;
      this.iconId = val.id
    },
    showMobileIcon(val){
      this.mobileIcon = true;
      this.iconId = val.id
    },
    showWhatsAppIcon(val){
      this.whatsAppIcon = true;
      this.iconId = val.id
    },
    showWeChatIcon(val){
      this.weChatIcon = true;
      this.iconId = val.id
    },
    //  跳转到联系人详情
    goContactDetail(val){
      const contactDetail = {
        id: val.id,
        cid: val.customerId,
      }
      this.$emit('showDetailDialog', contactDetail)
    },
    // 切换页数
    handleCurrentChange(val){
      this.getContactList(this.copyContactList.id,val)
    },
    // 跳转linkin
    linkedinLinkShow(val) {
      this.SET_VISIBLE(true)
      this.SET_LINKIN_URL(val)
    },
    // 确定跳转linkin
    confirm(){
      this.linkeinVisible = false
      window.open(this.linkinUrl)
    },
    handleClose(){
      this.linkeinVisible = false
    }


    /*
    // 编辑联系人
    editConcat(val){
      this.$refs.newcontactDialog.getContact(val,1)
      this.$refs.newcontactDialog.dialogVisible = true ;
    },
    // 删除联系人
    deleteConcat(id){
      let confirmRes = this.$confirm('删除后，该联系人不可找回', '确定删除该联系人吗？', {
          confirmButtonText: '确认删除',
          cancelButtonText: '再想想',
          type: 'warning'
      }).then(()=>{
        deleteContact(id)
          .then(res=>{
            if(res.rspResult.bizCode == 200){
              // console.log('删除联系人Success');
              alert('删除联系人Success');
            }
          })
          .catch(err=> console.error('删除联系人失败', err) )
        })
        .catch(err=>{return err})
    }
    */
  },


  
}
</script>

<style  lang="scss" scoped>
  .data-hiding{
    width: 48px;
    height: 20px;
    background: #F5F7FA;
  }
  ::v-deep .el-button--small{
      padding: 12px 8px ;
  }
  ::v-deep .el-table__row{
    height: 64px;
  }
  .contact-table {
    font-size: 14px;
    
    ::v-deep .el-table {
      font-size: 14px !important;
    }
    .el-button {
      font-size: 14px;
      padding: 10px 16px !important;
    }
  }
  
  .referenceemail{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    // background-color: #e6a23c;
    margin-right: 6px;
    margin-bottom: 1px;
  }
  // 有效
  .emailType0{
    background-color: #6CD76C;
  }
  // 退订
  .emailType1{
    background-color: #A3A3A3;
  }
  // 手动排除
  .emailType2{
    background-color: #A3A3A3;
  }
  // 硬弹
  .emailType3{
    background-color: #FF6868;
  }
  // 软弹
  .emailType4{
    background-color: #FFCA56;
  }

</style>
<style lang="scss">
.table{
  .el-table__body-wrapper{
    scrollbar-width: thin !important;
    // scrollbar-color: red #0ff;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 7px;
    height: 7px !important;
  }
  .el-table__fixed{
    height: 100% !important;
  }
}
</style>